module.exports = __webpack_public_path__ + "static/main_logo-7f57ae2b92f7c55458331ed8a90ea132.png";